import { Outlet, useNavigate } from 'react-router-dom'
import { AppShell } from '@rb/ui'
import { getCurrentUser, clearCurrentUser } from '../lib/auth'

interface AppShellLayoutProps {
  navMode: 'client' | 'admin'
}

export function AppShellLayout({ navMode }: AppShellLayoutProps) {
  const navigate = useNavigate()
  const user = getCurrentUser()
  const shellUser = user ? { name: user.name, role: user.role } : null

  // super_admin always sees the admin sidebar, even on client routes (e.g. /settings)
  const effectiveNavMode = user?.role === 'super_admin' ? 'admin' : navMode

  function handleLogout() {
    clearCurrentUser()
    navigate('/login')
  }

  return (
    <AppShell navMode={effectiveNavMode} user={shellUser} onLogout={handleLogout}>
      <Outlet />
    </AppShell>
  )
}
